import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Button, Modal } from 'semantic-ui-react'
import { showModal } from 'ducks/app'

const InfoModal = (props) => {
  const { modal, showModal } = props
  return (
    <Modal open={modal.show} size={modal.size}>
      <Modal.Header>{modal.header}</Modal.Header>
      <Modal.Content>{modal.message}</Modal.Content>
      <Modal.Actions>
        <Button 
          icon='delete'
          type='button'
          color='red' 
          labelPosition='left' 
          content='Close'
          onClick={() => showModal(false, '', '')} />
      </Modal.Actions>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  modal: state.app.modal,
})

const mapDispatchToProps = {
  showModal
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(InfoModal)